export class TelefoneCelular {
    public ddd: string;
    public numero: string;

    constructor(telefoneCelular: any) {
        if (telefoneCelular === undefined) {
            telefoneCelular = {
                ddd: undefined,
                numero: undefined
            };

        }
        this.ddd = telefoneCelular.ddd;
        this.numero = telefoneCelular.numero;
    }
}



// WEBPACK FOOTER //
// ./src/app/resources/classes/telefone-celular.ts